import API from "../BaseURL";
import { getModemByExploitation } from "../exploitations/modems";

const configJson = {
    headers: {
      "content-type": "application/json",
    },
  };



export async function getAllIrrigations() {
    const res = API.get(`/irrigations/`, configJson);
    return (await res).data;
}


export async function getIrrigationInfo(irrigation_id) {
    const res = API.get(`/irrigations/${irrigation_id}`, configJson);
    return res;
}

export async function createIrrigation(data) {
    const res = API.post(`/irrigations/`, data, configJson);
    return res;
}

export async function updateIrrigation(irrigation_id, data) {
    const res = API.put(`/irrigations/${irrigation_id}/`, data, configJson);
    return res;
}

export async function deleteIrrigation(irrigation_id) {
    const res = API.delete(`/irrigations/${irrigation_id}/`, configJson);
    return res;
}

export async function getIrrigationByModem(modem_id) {
    const res = API.get(`/irrigations/modem/${modem_id}`, configJson);
    return res;
}


export async function getIrrigationByModemAndDate(modem_id, start_date, end_date) {
    const res = API.get(`/irrigations/modem/${modem_id}/date/${start_date}/${end_date}`, configJson);
    return res;
}


export async function getIrrigationByExploitation(exploitation_id) {
    const modems = await getModemByExploitation(exploitation_id);
    const irrigations = [];
    for (let modem of modems) {
        const res = await getIrrigationByModem(modem.modem_id);
        irrigations.push(...res.data);
    }
    return irrigations;
}



export async function getIrrigationByExploitationAndDate(exploitation_id, start_date, end_date) {
    const modems = await getModemByExploitation(exploitation_id);
    if (start_date === null || start_date === undefined) {
        // if the start date is null, we set it to 15 days ago
        start_date = new Date();
        start_date.setDate(start_date.getDate() - 15);
    }
    if (end_date === null || end_date === undefined) {
        // if the end date is null, we set it to now
        end_date = new
        Date();
    }
    
    const irrigations = [];
    for (let modem of modems) {
        const res = await getIrrigationByModemAndDate(modem.modem_manual_id, start_date, end_date);
        irrigations.push(...res.data);
    }
    return irrigations;
}
